/* eslint-disable react/prop-types */
/* eslint-disable react/function-component-definition */
/**
=========================================================
* Material Dashboard 2 React - v2.2.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-dashboard-react
* Copyright 2023 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

// Material Dashboard 2 React components
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import axios from "axios";
import BASE_URL from "config/Base_URL";
import { Snackbar, Grid, Typography, TextField } from "@mui/material";
import Swal from "sweetalert2";
import MyModal from "components/Modal";
import { useEffect, useState, useMemo } from "react";
import MDButton from "components/MDButton";
import Icon from "@mui/material/Icon";
import { useMaterialUIController } from "context";
import MDInput from "components/MDInput";
import MDTableCell from "@mui/material/TableCell";
import MDTableRow from "@mui/material/TableRow";
import MDTableBody from "@mui/material/TableBody";
import MDTable from "@mui/material/Table";
import { jsPDF } from "jspdf";
import autoTable from "jspdf-autotable";

const Data = ({ filterPurchase, setPembelianParent } = {}) => {
  const [controller] = useMaterialUIController();
  const { darkMode } = controller;
  const [open, setOpen] = useState(false);
  const [message, setMessage] = useState("");

  const [modalDeleteShow, setModalDeleteShow] = useState(false);
  const [modalDetailShow, setModalDetailShow] = useState(false);
  const [modalPaymentShow, setModalPaymentShow] = useState(false);

  const [invoice, setInvoice] = useState("");
  const [invoicePayment, setInvoicePayment] = useState("");
  const [namaUsaha, setNamaUsaha] = useState("");
  const [totalPembelian, setTotalPembelian] = useState("");
  const [totalPembayaran, setTotalPembayaran] = useState("");
  const [statusPembelian, setStatusPembelian] = useState("");
  const [tanggalPembelian, setTanggalPembelian] = useState("");
  const [catatan, setCatatan] = useState("");
  const [itemProduk, setItemProduk] = useState([]);
  const [payment, setPayment] = useState("");
  const [pembelian, setListPembelian] = useState([]);
  const [selectedDate, setSelectedDate] = useState("");
  const [maxPayment, setMaxPayment] = useState(0);
  const token = sessionStorage.getItem("token");

  const vertical = "top";
  const horizontal = "right";

  const handleClose = () => {
    setOpen(false);
  };

  const snackbarComponent = (
    <Snackbar
      anchorOrigin={{ vertical, horizontal }}
      open={open}
      onClose={handleClose}
      message={message}
      key={vertical + horizontal}
      autoHideDuration={4000}
    />
  );

  const formatRupiah = (angka) => {
    return new Intl.NumberFormat("id-ID", {
      style: "currency",
      currency: "IDR",
      minimumFractionDigits: 0,
    }).format(angka);
  };

  // ini digunakan untuk download nota purchase
  // ================================================================
  //                            DOWNLOAD NOTA
  // ================================================================

  const downloadNota = () => {
    const tinggiPerBaris = 6;
    const tinggiHeader = 25;
    const jarakSetelahTabel = 4;
    const tinggiTotalSection = 21;
    const tinggiTandaTangan = 20;
    const tinggiFooter = 40;
    const marginBawah = 0;

    const tinggiTabel = itemProduk.length * tinggiPerBaris;
    const tinggiKertas =
      tinggiHeader +
      tinggiTabel +
      jarakSetelahTabel +
      tinggiTotalSection +
      tinggiTandaTangan +
      tinggiFooter +
      marginBawah;

    const doc = new jsPDF({
      orientation: "landscape",
      unit: "mm",
      format: [297, tinggiKertas], // Perbesar ke 297mm landscape
    });

    // Header
    doc.setFont("helvetica", "bold");
    doc.setFontSize(16); // ini yang saya ganti rendi
    doc.text("WENMART", 190, 20, { align: "center" });
    doc.text("NOTA PEMBELIAN BARANG", 190, 30, { align: "center" });

    // Info transaksi
    doc.setFontSize(13); // ini yang saya ganti rendi
    const marginAtas = 6;
    let y = 10 + marginAtas;
    doc.text(`No. Invoice      : ${invoice}`, 10, y);
    y += 6;
    doc.text(`Tanggal           : ${tanggalPembelian}`, 10, y);
    y += 6;
    doc.text(`Nama Supplier: ${namaUsaha}`, 10, y);

    // Garis pemisah
    doc.setLineWidth(0.2);
    doc.line(10, 40, 287, 40); // Lebar disesuaikan

    // Tabel produk
    const startYTabel = y + 15;
    const tableWidth = 277;
    const tableHeight = tinggiTabel + 15;

    // Gambar border luar tabel
    doc.rect(10, startYTabel, tableWidth, tableHeight);

    // Header kolom
    doc.setFontSize(13); // ini yang saya ganti rendi
    doc.setFont("helvetica", "bold");

    const headerColumns = [
      { x: 10, width: 10, text: "No", align: "center" },
      { x: 20, width: 120, text: "Nama Produk", align: "left" },
      { x: 140, width: 20, text: "Qty", align: "center" },
      { x: 160, width: 20, text: "Unit", align: "center" },
      { x: 180, width: 40, text: "Harga", align: "right" },
      { x: 220, width: 67, text: "Subtotal", align: "right" },
    ];

    headerColumns.forEach((col) => {
      doc.text(col.text, col.x + col.width / 2, startYTabel + 4, { align: col.align });
    });

    // Isi tabel
    doc.setFont("helvetica", "normal");
    itemProduk.forEach((item, index) => {
      const rowY = startYTabel + 4 + (index + 1) * tinggiPerBaris;

      doc.text((index + 1).toString(), 15, rowY, { align: "center" }); // No
      doc.text(item.name, 22, rowY, { maxWidth: 115, align: "left" }); // Nama
      doc.text(item.amount.toString(), 150, rowY, { align: "center" }); // Qty
      doc.text(item.unit, 170, rowY, { align: "center" }); // Unit
      doc.text(formatRupiah(item.price).replace("Rp", "").trim(), 200, rowY, { align: "right" }); // Harga
      doc.text(formatRupiah(item.total).replace("Rp", "").trim(), 285, rowY, { align: "right" }); // Subtotal
    });

    // Total & tanda tangan
    let finalY = startYTabel + tableHeight + jarakSetelahTabel;
    finalY += 10;

    doc.setFontSize(13); // ini yang saya ganti rendi
    doc.text("PENJUAL", 17, finalY);
    doc.text("Pembeli / Penerima Barang", 46, finalY);
    doc.text("Dicetak Oleh", 103, finalY);

    doc.setFontSize(14);
    doc.setFont("helvetica", "medium");
    doc.text("Total Pembelian:", 180, finalY);
    doc.text(formatRupiah(totalPembelian), 285, finalY, { align: "right" });

    finalY += 7;
    doc.text("Total Pembayaran:", 180, finalY);
    doc.text(formatRupiah(totalPembayaran), 285, finalY, { align: "right" });

    finalY += 7;
    doc.text("Status:", 180, finalY);
    doc.text(statusPembelian, 285, finalY, { align: "right" });

    // Kotak tanda tangan
    doc.setLineWidth(0.1);
    doc.rect(10, finalY - 18, 35, 20);
    doc.rect(45, finalY - 18, 55, 20);
    doc.rect(100, finalY - 18, 30, 20);

    // Kotak total
    doc.rect(175, finalY - 18, 112, 6);
    doc.rect(175, finalY - 12, 112, 6);
    doc.rect(175, finalY - 6, 112, 8);

    // Footer
    finalY = tinggiKertas - marginBawah - 8;
    doc.setDrawColor(0);
    doc.setLineWidth(0.2);
    doc.line(30, finalY - 10, 267, finalY - 10);

    doc.setFontSize(10); // ini yang saya ganti rendi
    doc.setTextColor(80);
    doc.setFont("helvetica", "normal");
    doc.text("Terima kasih telah berbelanja di toko kami", 148.5, finalY - 4, { align: "center" });
    doc.text("Hubungi: 0812-3456-7890 | IG: @tjiangfuwen", 148.5, finalY, { align: "center" });

    doc.save(`nota_${invoice}.pdf`);
  };

  // ================================================================
  //                            DETAIL PEMBELIAN
  // ================================================================

  const handleDetail = async (idPurchase) => {
    try {
      const response = await axios.get(`${BASE_URL}/purchase/details?id=${idPurchase}`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      const pembelianResponse = response.data.data;
      setInvoice(pembelianResponse.invoiceNumber);
      setNamaUsaha(pembelianResponse.name);
      setTanggalPembelian(pembelianResponse.date);
      setTotalPembayaran(pembelianResponse.payment);
      setTotalPembelian(pembelianResponse.totalPrice);
      setStatusPembelian(pembelianResponse.paymentStatus);
      setCatatan(pembelianResponse.note);
      setItemProduk(pembelianResponse.items);

      setModalDetailShow(true);
    } catch (error) {
      console.log(error);
      Swal.fire("Gagal", "Gagal menampilkan detail pembelian!", "error");
    }
  };

  const renderFormDetail = (
    <Grid container spacing={2}>
      {/* Invoice Number */}
      <Grid item xs={12}>
        <MDInput
          fullWidth
          disabled
          size="xxl"
          label="Invoice Number"
          variant="outlined"
          value={invoice}
          InputLabelProps={{ shrink: true }}
        />
      </Grid>

      {/* Nama Supplier */}
      <Grid item xs={12}>
        <MDInput
          fullWidth
          disabled
          size="xxl"
          label="Nama Supplier"
          variant="outlined"
          value={namaUsaha}
          InputLabelProps={{ shrink: true }}
        />
      </Grid>

      {/* Total Pembelian */}
      <Grid item xs={12}>
        <MDInput
          fullWidth
          disabled
          size="xxl"
          label="Total Pembelian"
          variant="outlined"
          value={formatRupiah(totalPembelian)}
          InputLabelProps={{ shrink: true }}
        />
      </Grid>

      {/* Total Pembayaran */}
      <Grid item xs={12}>
        <MDInput
          fullWidth
          disabled
          size="xxl"
          label="Total Pembayaran"
          variant="outlined"
          value={formatRupiah(totalPembayaran)}
          InputLabelProps={{ shrink: true }}
        />
      </Grid>

      {/* Status */}
      <Grid item xs={12}>
        <MDInput
          fullWidth
          disabled
          size="xxl"
          label="Status"
          variant="outlined"
          value={statusPembelian}
          InputLabelProps={{ shrink: true }}
        />
      </Grid>

      {/* Tanggal Pembelian */}
      <Grid item xs={12}>
        <MDInput
          fullWidth
          disabled
          size="xxl"
          label="Tanggal Pembelian"
          variant="outlined"
          value={tanggalPembelian}
          InputLabelProps={{ shrink: true }}
        />
      </Grid>

      {/* Catatan */}
      <Grid item xs={12}>
        <MDInput
          fullWidth
          disabled
          label="Catatan"
          variant="outlined"
          value={catatan}
          multiline
          rows={2}
          InputLabelProps={{ shrink: true }}
          sx={{
            "& .MuiOutlinedInput-root": {
              alignItems: "flex-start",
            },
            "& textarea": {
              resize: "vertical",
              minHeight: "80px",
            },
          }}
        />
        <Typography variant="caption" color="textSecondary">
          Maksimal 250 karakter • {catatan.length}/250
        </Typography>
      </Grid>

      {/* Tabel Pembelian */}
      <Grid item xs={12}>
        <MDTable>
          <MDTableBody>
            <MDTableRow>
              <MDTableCell sx={{ fontWeight: "bold" }}>Nama Produk</MDTableCell>
              <MDTableCell sx={{ fontWeight: "bold", textAlign: "right" }}>
                Harga Satuan
              </MDTableCell>
              <MDTableCell sx={{ fontWeight: "bold", textAlign: "center" }}>Unit</MDTableCell>
              <MDTableCell sx={{ fontWeight: "bold", textAlign: "center" }}>Jumlah</MDTableCell>
              <MDTableCell sx={{ fontWeight: "bold", textAlign: "right" }}>Subtotal</MDTableCell>
            </MDTableRow>
            {itemProduk.map((product) => (
              <MDTableRow key={product.id}>
                <MDTableCell>{product.name}</MDTableCell>
                <MDTableCell sx={{ textAlign: "right" }}>{formatRupiah(product.price)}</MDTableCell>
                <MDTableCell sx={{ textAlign: "center" }}>{product.unit}</MDTableCell>
                <MDTableCell sx={{ textAlign: "center" }}>{product.amount}</MDTableCell>
                <MDTableCell sx={{ textAlign: "right" }}>{formatRupiah(product.total)}</MDTableCell>
              </MDTableRow>
            ))}
            <MDTableRow>
              <MDTableCell colSpan={4} sx={{ textAlign: "right", fontWeight: "bold" }}>
                Total:
              </MDTableCell>
              <MDTableCell sx={{ textAlign: "right", fontWeight: "bold" }}>
                {formatRupiah(totalPembelian)}
              </MDTableCell>
            </MDTableRow>
          </MDTableBody>
        </MDTable>
      </Grid>

      {/* Tombol Download Nota */}
      <Grid item xs={12}>
        <MDBox display="flex" justifyContent="flex-end">
          <MDButton variant="gradient" color="info" onClick={downloadNota}>
            <Icon>download</Icon>&nbsp;Download Nota
          </MDButton>
        </MDBox>
      </Grid>
    </Grid>
  );

  // ================================================================
  //                            DELETE PEMBELIAN
  // ================================================================

  const handleDelete = async () => {
    try {
      const response = await axios.delete(`${BASE_URL}/purchases/delete?id=${invoice}`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      setModalDeleteShow(false);
      Swal.fire("Berhasil", "Pembelian berhasil dihapus", "success");
      fetchPembelian();
    } catch (error) {
      setModalDeleteShow(false);
      console.log(error);
      Swal.fire("Gagal", "Pembelian gagal dihapus", "error");
    }
  };

  // ================================================================
  //                            BAYAR PEMBELIAN
  // ================================================================

  const handleOpenModal = (item) => {
    setInvoicePayment(item.invoiceNumber);
    const max = item.totalPrice - item.payment;
    setMaxPayment(max);
    setPayment(item.totalPrice);
    setModalPaymentShow(true);
  };

  const handlePayment = async () => {
    try {
      const requestBody = {
        payment: payment,
      };

      await axios.put(`${BASE_URL}/pay/debts?invoiceNumber=${invoicePayment}`, requestBody, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      setModalPaymentShow(false);
      Swal.fire("Berhasil", "Pembelian berhasil dibayarkan", "success");
      fetchPembelian();
    } catch (error) {
      setModalPaymentShow(false);
      console.log(error);
      Swal.fire("Gagal", "Pembelian gagal dibayarkan", "error");
    }
  };

  const renderFormPayment = (
    <Grid container spacing={2} maxWidth="lg">
      <Grid item xs={12}>
        <MDBox mb={2}>
          <MDInput
            fullWidth
            size="xxl"
            label="Bayar"
            variant="outlined"
            value={formatRupiah(payment)}
            onChange={(e) => {
              const val = e.target.value.replace(/[^0-9]/g, "");
              if (parseInt(val || "0") <= maxPayment) {
                setPayment(val);
              } else {
                setModalPaymentShow(false);
                Swal.fire("Peringatan", "Pembayaran melebihi hutang!", "warning");
              }
            }}
            InputLabelProps={{ shrink: true }}
          />
        </MDBox>
      </Grid>
    </Grid>
  );

  // ================================================================
  //                            GET PEMBELIAN
  // ================================================================

  const getTodayDate = () => {
    const today = new Date();
    const year = today.getFullYear();
    const month = String(today.getMonth() + 1).padStart(2, "0");
    const day = String(today.getDate()).padStart(2, "0");

    return `${year}-${month}-${day}`;
  };

  const fetchPembelian = async (dateValue) => {
    const tanggal = dateValue || getTodayDate();
    try {
      const config = {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      };

      const response = await axios.get(
        `${BASE_URL}/purchases${tanggal ? `?date=${tanggal}` : ""}`,
        config
      );

      const responseData = response.data;
      if (responseData && responseData.data) {
        const dataArray = Array.isArray(responseData.data)
          ? responseData.data
          : [responseData.data];
        setListPembelian(dataArray);
        setPembelianParent(dataArray);
      } else {
        setListPembelian([]);
        setPembelianParent(responseData.data);
      }

      setMessage("Berhasil mengambil data pembelian");
      setOpen(true);
    } catch (error) {
      console.error("Error:", error);
      setMessage("Tidak ada data pembelian di bulan ini");
      setOpen(true);
    }
  };

  useEffect(() => {
    fetchPembelian();
  }, [setPembelianParent]);

  const handleDateChange = (e) => {
    const value = e.target.value;
    setSelectedDate(value);
    if (value) {
      fetchPembelian(value);
    }
  };

  const inputDate = (
    <MDInput
      style={{ width: "100%" }}
      type="date"
      value={selectedDate}
      onChange={handleDateChange}
    />
  );

  const sortedPembelian = useMemo(() => {
    if (!pembelian) return [];
    return [...pembelian].sort((a, b) => new Date(a.date) - new Date(b.date));
  }, [pembelian]);

  const filteredPembelian = useMemo(() => {
    if (!filterPurchase) return sortedPembelian;
    return sortedPembelian.filter(
      (item) => (item.name || "").toLowerCase() === (filterPurchase.name || "").toLowerCase()
    );
  }, [sortedPembelian, filterPurchase]);

  const columns = useMemo(
    () => [
      { Header: "No", accessor: "no", width: "1%", align: "left" },
      { Header: "No Faktur", accessor: "no_faktur", width: "20%", align: "left" },
      { Header: "Nama Suppiler", accessor: "nama_usaha", align: "left" },
      { Header: "Tanggal Pembelian", accessor: "tanggal_pembelian", align: "center" },
      { Header: "Total Pembelian", accessor: "total_pembelian", align: "center" },
      { Header: "Total Pembayaran", accessor: "total_pembayaran", align: "center" },
      { Header: "Status Pembayaran", accessor: "status_pembayaran", align: "center" },
      { Header: "action", accessor: "action", align: "center" },
    ],
    []
  );

  const rows = useMemo(
    () =>
      filteredPembelian.map((item, index) => ({
        no: index + 1,
        no_faktur: (
          <MDTypography variant="caption" color={darkMode ? "white" : "dark"} fontWeight="medium">
            {item.invoiceNumber || " - "}
          </MDTypography>
        ),
        nama_usaha: (
          <MDTypography variant="caption" color={darkMode ? "white" : "dark"} fontWeight="medium">
            {item.name || " - "}
          </MDTypography>
        ),
        tanggal_pembelian: (
          <MDTypography variant="caption" color={darkMode ? "white" : "dark"} fontWeight="medium">
            {item.date || " - "}
          </MDTypography>
        ),
        total_pembayaran: (
          <MDTypography variant="caption" color={darkMode ? "white" : "dark"} fontWeight="medium">
            {formatRupiah(item.payment) || " - "}
          </MDTypography>
        ),
        total_pembelian: (
          <MDTypography variant="caption" color={darkMode ? "white" : "dark"} fontWeight="medium">
            {formatRupiah(item.totalPrice) || " - "}
          </MDTypography>
        ),
        status_pembayaran: (
          <MDTypography variant="caption" color={darkMode ? "white" : "dark"} fontWeight="medium">
            {item.paymentStatus || " - "}
          </MDTypography>
        ),
        action: (
          <MDBox display="flex" alignItems="center" mt={{ xs: 2, sm: 0 }} ml={{ xs: -1.5, sm: 0 }}>
            <MDBox mr={1}>
              <MDButton
                variant="text"
                color="error"
                onClick={() => {
                  setModalDeleteShow(true);
                  setInvoice(item.invoiceNumber);
                }}
              >
                <Icon>delete</Icon>&nbsp;delete
              </MDButton>
            </MDBox>
            <MDButton
              variant="text"
              color={darkMode ? "white" : "info"}
              onClick={() => {
                handleDetail(item.invoiceNumber);
              }}
            >
              <Icon>priority_high</Icon>&nbsp;detail
            </MDButton>
            <MDButton
              variant="text"
              color={darkMode ? "white" : "success"}
              onClick={() => handleOpenModal(item)}
              disabled={item.statusPayment === "LUNAS" || item.payment >= item.totalPrice}
            >
              <Icon>payment</Icon>&nbsp;Bayar
            </MDButton>
            {/*<MDButton variant="text" color="success">*/}
            {/*  <Icon>edit</Icon>&nbsp;edit*/}
            {/*</MDButton>*/}
          </MDBox>
        ),
      })),
    [filteredPembelian, darkMode]
  );

  const modalDelete = (
    <MyModal
      show={modalDeleteShow}
      submitText="Hapus"
      variant="danger"
      onSubmit={handleDelete}
      onHide={() => setModalDeleteShow(false)}
      colorButtonSubmit="primary"
      body="Apakah anda yakin ingin menghapus data ini?"
    />
  );

  const modalDetail = (
    <MyModal
      show={modalDetailShow}
      onHide={() => setModalDetailShow(false)}
      title="Detail Pembelian"
      body={renderFormDetail}
    />
  );

  const modalPayment = (
    <MyModal
      show={modalPaymentShow}
      onHide={() => setModalPaymentShow(false)}
      colorButtonSubmit="primary"
      title="Pembayaran"
      onSubmit={handlePayment}
      body={renderFormPayment}
    />
  );

  return {
    columns,
    rows,
    inputDate,
    snackbarComponent,
    modalDelete,
    pembelian,
    modalDetail,
    modalPayment,
  };
};

export default Data;
